module.exports = __webpack_public_path__ + "static/lavarel-2ede0a00140605b8889c672454f49adf.png";